import { TableHeaderCell } from 'common/components';
import type { TableFilterOption } from '../CallsTable';

type PartyStatusCellProps = {
    filterLeadStatus: string;
    partyStageOptions: TableFilterOption[];
    onFilterLeadStatus: (value: string) => void;
};

export const PartyStatusCell = ({ filterLeadStatus, partyStageOptions, onFilterLeadStatus }: PartyStatusCellProps) => {
    const options = [{ value: '', label: 'All statuses' }, ...partyStageOptions];

    return (
        <TableHeaderCell
            label='Party status'
            isSearchable
            filterOptions={{
                options,
                selectedValue: filterLeadStatus,
                onChange: onFilterLeadStatus,
            }}
        />
    );
};
